import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Headline from '../Headline/Headline'
import ContentfulButtonV3 from './Buttons/V3/ContentfulButtonV3'

class TrustPilot extends Component {
  // setting ref for TrustPilot
  trustPilot = React.createRef()

  componentDidMount() {
    this.loadTrustPilot()
  }

  loadTrustPilot = () => {
    if (
      window.Trustpilot &&
      this.trustPilot &&
      this.trustPilot.current &&
      process.env.NODE_ENV !== 'development'
    ) {
      window.Trustpilot.loadFromElement(this.trustPilot.current)
    }
  }

  render() {
    const {
      data: { dataTags, layout, gridHeight, button, trustPilotHeadline }
    } = this.props
    const attr = {}
    if (dataTags && dataTags.length && dataTags[0] !== 'None') {
      attr['data-tags'] = dataTags
    }

    let templateId = '53aa8912dec7e10d38f59f36' // row layout
    let styleHeight = 140

    if (layout === 'Grid') {
      templateId = '539adbd6dec7e10e686debee' //  grid layout
      styleHeight = gridHeight
    }

    /* eslint-disable react/jsx-props-no-spreading */
    return process.env.GATSBY_ACTIVE_ENV !== 'testing' ? (
      <div id="trusted-widget-wrapper">
        {trustPilotHeadline ? <Headline data={trustPilotHeadline} /> : null}
        <div
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id={templateId}
          data-businessunit-id="551cfda10000ff00057e75b0"
          data-style-height={`${styleHeight}px`}
          data-style-width="100%"
          data-theme="light"
          {...attr}
          data-stars="4,5"
          ref={this.trustPilot}
        >
          <a
            href="https://www.trustpilot.com/review/avant.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            TrustPilot
          </a>
        </div>
        {/* {button ? (
            <AppButton
              className="trusted-button button--primary"
              style={button.style}
              dataEvent={button.dataEvent}
              pageCategory={button.pageCategory}
            >
              &gt; All Reviews
            </AppButton>
          ) : null} */}
        {button ? <ContentfulButtonV3 data={button} /> : null}
      </div>
    ) : (
      <div />
    )
  }
}

TrustPilot.defaultProps = {
  data: {}
}

TrustPilot.propTypes = {
  data: PropTypes.object
}
export default TrustPilot
